/**
 * The shape of the code that proves an address.
 *
 * Its own module, with no imports, because both sides need it: the server
 * configures the plugin with it and the registration form tells the reader how
 * long they have and how many boxes to fill. Reading it off `./server.ts` would
 * drag the whole auth server — database adapter included — into a client
 * bundle for the sake of two numbers.
 *
 * Six digits, ten minutes. Long enough to survive a mail that takes a minute to
 * arrive and a person who switches apps to read it; short enough that a code
 * left on a screen somewhere is worthless by the time anybody finds it.
 */
export const OTP_LENGTH = 6
export const OTP_TTL_SECONDS = 10 * 60
export const OTP_TTL_MINUTES = OTP_TTL_SECONDS / 60
